import React from "react"
import useMediaQuery from '@mui/material/useMediaQuery'
import { Table } from "react-bootstrap"
import { formatMoney, formatDiscountPercent } from "../../helpers/utils"
import { buildSalesOrderFields } from "../helpers/salesOrderHelpers"
import ClientHeader from '../../components/ClientHeader/ClientHeader'
import DetailsSummarySection from '../../components/details/summary/DetailsSummarySection'
import DetailStatusMobileHeader from '../../components/DetailStatusMobileHeader'
import TotalsSummaryCard from '../../components/TotalsSummaryCard'
import { SALES_ORDER_HEADER_CONFIG } from '../constants/orderConstants'
import { layoutMobileMediaQuery } from '../../layout/layoutConstants'
import SalesOrderDetailsTabMobileLines from '../mobile/SalesOrderDetailsTabMobileLines'

const SalesOrderDetailsTab = ({
  salesOrder,
  statusUI,
  fallbackStatus,
  showStatusInHeader = false,
}) => {
  if (!salesOrder) return null

  const fields = buildSalesOrderFields(salesOrder)
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)
  const items = salesOrder?.sales_order_items ?? []
  const totalRows = [
    {
      label: 'SUBTOTAL:',
      value: formatMoney(Number(salesOrder.subtotal || 0))
    },
    {
      label: 'DESCUENTO:',
      value: `-${formatMoney(Number(salesOrder.discount || 0))}`,
      negative: true
    },
    {
      label: 'IMPUESTOS:',
      value: formatMoney(Number(salesOrder.taxes || 0))
    },
    {
      label: 'TOTAL:',
      value: formatMoney(Number(salesOrder.total || 0)),
      strong: true,
      dividerBefore: true
    }
  ]

  return (
    <div className="container-fluid px-0">
      <div>
        {showStatusInHeader ? (
          <DetailStatusMobileHeader
            title="Detalles de Sales Order"
            statusUI={statusUI}
            fallbackStatus={fallbackStatus}
          />
        ) : (
          <>
            <div className="show-product-header">
              <h3 className="margin-text-subtitle">
                Detalles de Sales Order
              </h3>
            </div>
            <hr />
          </>
        )}
        <ClientHeader
          data={salesOrder}
          config={SALES_ORDER_HEADER_CONFIG}
        />
        <hr />
        <DetailsSummarySection
          summaryFields={fields}
          summaryTitle="DETALLES DE SALES ORDER"
          summaryOpenLabel="Abrir detalles de sales order"
          summaryCloseLabel="Cerrar detalles de sales order"
        />
        <hr />
        <div className="mr-85 mb-10">
          <b>Productos en Pedido ERP:</b>
        </div>
        {isMobileLayout ? (
          <SalesOrderDetailsTabMobileLines items={items} />
        ) : (
          <Table hover responsive>
            <thead className="table-header-gray-mui">
              <tr>
                <th>CÓDIGO</th>
                <th>PRODUCTO</th>
                <th>UNIDAD</th>
                <th>CANTIDAD</th>
                <th>PRECIO</th>
                <th>% DESCUENTO</th>
                <th>SUB-TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                items.map((item, index) => (
                  <tr key={index}>
                    <td className="order-td-text">{item.product_db_ref}</td>
                    <td className="order-td-text">{item.product_name}</td>
                    <td className="order-td-text">{item.package_unit}</td>
                    <td className="order-td-money">{Number(item.quantity || 0).toFixed(2)}</td>
                    <td className="order-td-money">{formatMoney(Number(item.price || 0))}</td>
                    <td className="order-td-money">{formatDiscountPercent(item.discount)}</td>
                    <td className="order-td-money">{formatMoney(Number(item.gross_price || 0))}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="order-td-text">
                    No hay resultados
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
        <TotalsSummaryCard rows={totalRows} />
      </div>
    </div>
  )
}

export default SalesOrderDetailsTab
